/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-contact-w': {
    width: 16,
    height: 16,
    viewBox: '0 0 12.48 13.42',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M5.07 5.71a1.78 1.78 0 0 0 1.79-1.78v-1.6a1.78 1.78 0 0 0-3.56 0v1.6a1.78 1.78 0 0 0 1.77 1.78z"/><path pid="1" class="cls-2" d="M5.07 6.26A2.33 2.33 0 0 0 7.4 3.93v-1.6a2.33 2.33 0 0 0-4.66 0v1.6a2.33 2.33 0 0 0 2.33 2.33zM3.29 2.33a1.78 1.78 0 0 1 3.56 0v1.6a1.78 1.78 0 0 1-3.56 0z"/><path pid="2" class="cls-2" d="M9.87 7.94a3.35 3.35 0 0 0-2.55-2 1.06 1.06 0 0 0-.3 0 1.78 1.78 0 0 0-.93.34 1.9 1.9 0 0 1-1 .36 1.79 1.79 0 0 1-1-.37 1.49 1.49 0 0 0-1.21-.37A3.6 3.6 0 0 0 .43 7.57l.49.26A3.1 3.1 0 0 1 3 6.43c.24-.07.48.07.76.25a2.3 2.3 0 0 0 1.29.45 2.41 2.41 0 0 0 1.3-.44 1 1 0 0 1 .79-.24A3 3 0 0 1 9.28 8 2.74 2.74 0 0 0 7 10.67v.18a16.72 16.72 0 0 1-1.92.15A16 16 0 0 1 2 10.67C1.34 10.54.55 10.32.55 10v-.45L0 9.58v.47c0 .56.53.88 1.89 1.16a16.68 16.68 0 0 0 3.22.31 17 17 0 0 0 2-.13 2.74 2.74 0 1 0 2.76-3.45zm1.25 3H10v1.21h-.53v-1.23H8.34v-.52h1.13V9.21H10v1.19h1.13z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/add-contact-w.js